<script lang="ts">
	import { Flip } from '$lib/utils/flip';
	import { onMount } from 'svelte';

	const iconEnd = [
		{
			id: 'top',
			keyframes: [
				{ offset: 0.5, transform: `translateY(0px)` },
				{ offset: 1, transform: `translateY(0px) rotate(45deg)` }
			]
		},
    {
			id: 'bottom',
			keyframes: [
				{ offset: 0.5, transform: `translateY(0px)` },
				{ offset: 1, transform: `translateY(0px) rotate(45deg)` }
			]
		},
    {
			id: 'base',
			keyframes: [
				{ offset: 0.5, transform: `translateY(0px)` },
				{ offset: 1, transform: `translateY(0px) rotate(-45deg)` }
			]
		},
	];

	const iconStart = [
		{
			id: 'top',
			keyframes: [
				{ offset: 0.5, transform: `translateY(0px) rotate(0deg)` },
        { offset: 1, transform: `translateY(-25px)` }
			]
		},
    {
			id: 'bottom',
			keyframes: [
				{ offset: 0.5, transform: `translateY(0px) rotate(0deg)` },
        { offset: 1, transform: `translateY(25px)` }
			]
		},
    {
			id: 'base',
			keyframes: [
				{ offset: 0.5, transform: `translateY(0px) rotate(0deg)` },
				{ offset: 1, transform: `translateY(0px) rotate(0deg)` },
			]
		}
	];

	function handleSwitch() {
		if (svg.classList.contains('open')) {
			svg.classList.remove('open');
			flip.animateElements(iconStart, { fill: 'forwards', delay: 266 });
		} else {
      svg.classList.add('open');
			flip.animateElements(iconEnd, { fill: 'forwards', delay: 266 });
		}
	}

  $effect( () => {
    open
    if(!flip) return
    handleSwitch()
  })

	onMount(() => {
		const elements = [...svg.querySelectorAll('.rect-group')] as HTMLElement[];
		flip = new Flip(elements, { duration: 400 });
	});

	let { class: className = 'w-full h-full', open = $bindable() } = $props();

	let svg: SVGElement;

	let flip: Flip;

</script>

<!-- svelte-ignore a11y_no_static_element_interactions -->
<!-- svelte-ignore a11y_click_events_have_key_events -->
<div class="menu-icon h-full w-full">
	<svg bind:this={svg} style="--delay: 0;" class="svg {className}" width="100" height="100" viewBox="0 0 80 80" version="1.1" id="svg1">
		<defs id="defs1" />
		<g id="layer1" transform="">
			<g id="base" class="rect-group">
				<rect class="rect" style="stroke-width:0.28672" id="base-rect" width="80" height="8" x="0" y="35" />
			</g>

			<g id="top" class="rect-group">
				<rect class="rect" style="stroke-width:0.28672" id="top-rect" width="80" height="8" x="0" y="35" />
			</g>

			<g id="bottom" class="rect-group">
				<rect class="rect" style="stroke-width:0.28672" id="bottom-rect" width="80" height="8" x="0" y="35" />
			</g>
		</g>
	</svg>
</div>

<style lang="postcss">
	@reference "tailwindcss/theme";

	.svg * {
		transform-origin: center center;
	}

	.rect {
		@apply rounded-lg;
		fill: black;
		rx: 4;
	}

	#base {
		transform: rotate(0deg);
	}

	#top {
		transform: translateY(-25px);
		/*animation-name: n;*/
	}

	#bottom {
		transform: translateY(25px);
	}
</style>
